import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import {useKeycloak} from "@react-keycloak/web";
import {Badge, IconButton} from "@mui/material";
import {Link} from "react-router-dom";
import Search from "./Search";
import LogoSignet from "./LogoSignet";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ListIcon from '@mui/icons-material/List';
import StorefrontIcon from '@mui/icons-material/Storefront';
import InventoryIcon from '@mui/icons-material/Inventory';
import SubjectIcon from '@mui/icons-material/Subject';

export default function TopBar() {

    const {keycloak, initialized} = useKeycloak();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    return (

        <Box sx={{flexGrow: 1}}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={() => {
                            // navigate('/')
                            window.location.href = "/"
                        }}
                        color="inherit"
                    >
                        <LogoSignet/>
                    </IconButton>

                    <Search/>

                    <IconButton component={Link} to={"/cart"} color="inherit" sx={{mx: 2}}>
                        <Badge badgeContent={1}>
                            <ShoppingCartIcon/>
                        </Badge>
                    </IconButton>


                    <React.Fragment>
                        <Box sx={{display: 'flex', alignItems: 'center', textAlign: 'center'}}>
                            <Tooltip title="My account">
                                <IconButton
                                    onClick={handleClick}
                                    size="small"
                                    aria-controls={open ? 'account-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                >
                                    <MenuIcon sx={{color: 'white', bgcolor: 'inherit'}}/>
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Menu
                            anchorEl={anchorEl}
                            id="account-menu"
                            open={open}
                            onClose={handleClose}
                            onClick={handleClose}
                            PaperProps={{
                                elevation: 0,
                                sx: {
                                    overflow: 'visible',
                                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                    mt: 1.5,
                                    '& .MuiAvatar-root': {
                                        width: 32,
                                        height: 32,
                                        ml: -0.5,
                                        mr: 1,
                                    },
                                    '&:before': {
                                        content: '""',
                                        display: 'block',
                                        position: 'absolute',
                                        top: 0,
                                        right: 14,
                                        width: 10,
                                        height: 10,
                                        bgcolor: 'background.paper',
                                        transform: 'translateY(-50%) rotate(45deg)',
                                        zIndex: 0,
                                    },
                                },
                            }}
                            transformOrigin={{horizontal: 'right', vertical: 'top'}}
                            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                        >
                            <MenuItem component={Link}
                                      to={`/mom`}>
                                <ListItemIcon>
                                    <DashboardIcon fontSize="small"/>
                                </ListItemIcon>
                                Baza kart
                            </MenuItem>
                            <MenuItem component={Link}
                                      to={`/sets`}>
                                <ListItemIcon>
                                    <ListIcon fontSize="small"/>
                                </ListItemIcon>
                                Lista setów
                            </MenuItem>
                            <MenuItem component={Link}
                                      to={`/offers`}>
                                <ListItemIcon>
                                    <ListIcon fontSize="small"/>
                                </ListItemIcon>
                                Oferty
                            </MenuItem>
                            <MenuItem component={Link} to={`/user/guildmage`}>
                                <ListItemIcon>
                                    <InventoryIcon fontSize="small"/>
                                </ListItemIcon>
                                Sklep
                            </MenuItem>
                            <MenuItem component={Link} to={`/shop/merch`}>
                                <ListItemIcon>
                                    <StorefrontIcon fontSize="small"/>
                                </ListItemIcon>
                                Merch
                            </MenuItem>
                            <MenuItem component={Link} to={`/shop/events`}>
                                <ListItemIcon>
                                    <EmojiEventsIcon fontSize="small"/>
                                </ListItemIcon>
                                Wydarzenia
                            </MenuItem>
                            {initialized && !!keycloak.authenticated && (
                                <>
                                    <Divider/>
                                    <MenuItem component={Link}
                                              to={'/account/collection'}>
                                        <ListItemIcon>
                                            <DashboardCustomizeIcon fontSize="small"/>
                                        </ListItemIcon>
                                        Moja kolekcja
                                    </MenuItem>
                                </>
                            )}
                            <Divider/>

                            <MenuItem component={Link}
                                      to={`/docs/terms`}>
                                <ListItemIcon>
                                    <SubjectIcon fontSize="small"/>
                                </ListItemIcon>
                                Regulamin
                            </MenuItem>

                            <MenuItem component={Link}
                                      to={`/docs/privacy`}>
                                <ListItemIcon>
                                    <SubjectIcon fontSize="small"/>
                                </ListItemIcon>
                                Polityka Prywatności
                            </MenuItem>

                            <Divider/>
                            {initialized && !keycloak.authenticated && (
                                <MenuItem onClick={() => keycloak.login()}>
                                    <ListItemIcon>
                                        <Logout fontSize="small"/>
                                    </ListItemIcon>
                                    Login
                                </MenuItem>
                            )}
                            {initialized && !!keycloak.authenticated && (
                                <MenuItem onClick={() => keycloak.logout({redirectUri: 'https://guildmage.eu/mom'})}>
                                    <ListItemIcon>
                                        <Logout fontSize="small"/>
                                    </ListItemIcon>
                                    Logout {keycloak.tokenParsed.preferred_username}
                                </MenuItem>
                            )}
                        </Menu>
                    </React.Fragment>

                </Toolbar>
            </AppBar>
        </Box>
    );
}
